import request from '../../utils/request';
import { Result } from '../../models/general';
import {
  WpsDeadlineView,
  SifPreflightView,
  WpsSifSubmissionView,
  KsaWpsSubmissionView,
  KsaMudadMarkUploadedInput,
} from '../../models/payroll';
import { AxiosResponse } from 'axios';

export async function getWpsDeadline(year: number, month: number): Promise<Result<WpsDeadlineView>> {
  const response = await request.get<Result<WpsDeadlineView>>(`Wps/Deadline/${year}/${month}`);
  return response.data;
}

export async function getSifPreflight(year: number, month: number): Promise<Result<SifPreflightView>> {
  const response = await request.get<Result<SifPreflightView>>(`Wps/Preflight/${year}/${month}`);
  return response.data;
}

export async function generateSif(year: number, month: number): Promise<void> {
  const response: AxiosResponse<Blob> = await request.post(
    `Wps/GenerateSif/${year}/${month}`,
    {},
    {
      responseType: 'blob',
      headers: { 'Content-Type': 'application/json' },
      validateStatus: () => true,
    }
  );

  if (response.status !== 200) {
    const text = await (response.data as Blob).text();
    try {
      const json = JSON.parse(text);
      const messages = (json.errors || [])
        .map((e: { description?: string; message?: string }) => e.description || e.message || '')
        .filter(Boolean);
      throw new Error(messages.join('\n') || `SIF generation failed (${response.status})`);
    } catch (e) {
      if (e instanceof Error && e.message.includes('\n')) throw e;
      throw new Error(text || `SIF generation failed (${response.status})`);
    }
  }

  const headers = response.headers as Record<string, string>;
  const cd = headers['content-disposition'] || headers['Content-Disposition'];
  let fileName = `SIF_${year}_${String(month).padStart(2, '0')}_${Date.now()}.sif`;
  if (cd?.includes('filename=')) {
    try {
      const extracted = cd.split('filename=')[1].split(';')[0].trim().replace(/"/g, '');
      if (extracted) fileName = extracted;
    } catch { /* keep fallback */ }
  }

  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

export async function markWpsSubmitted(year: number, month: number): Promise<Result<boolean>> {
  const response = await request.post<Result<boolean>>(`Wps/MarkSubmitted/${year}/${month}`);
  return response.data;
}

export async function getWpsHistory(): Promise<Result<WpsSifSubmissionView[]>> {
  const response = await request.get<Result<WpsSifSubmissionView[]>>('Wps/History');
  return response.data;
}

export async function markMudadUploaded(
  year: number,
  month: number,
  input: KsaMudadMarkUploadedInput,
): Promise<Result<boolean>> {
  const response = await request.post<Result<boolean>>(`Wps/MarkUploaded/${year}/${month}`, input);
  return response.data;
}

export async function getKsaWpsHistory(): Promise<Result<KsaWpsSubmissionView[]>> {
  const response = await request.get<Result<KsaWpsSubmissionView[]>>('Wps/History');
  return response.data;
}
